module.exports = __webpack_public_path__ + "img/6-2.d22c92c4.png";